import HeaderBar from '@/components/headerbar';
import fabric from '@/pages/customize/utils/fabric';
import { initCircle, initRect } from '@/pages/tshirt/init';
import { useContext, useEffect, useState } from 'react';
import ProductBuy from '../../components/productBuy';
import Constant from '../../constant';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { myContext } from '../../context-manager';
import ga4Api from '@/packages/jsapi/logger/ga4';

let canvasIns = null;
const canvasConfig = {
  yResolution: 100,
  customWidth: window.innerWidth,
  customHeight: window.innerWidth * 1.2 * 0.8
};
const Home = (props: any) => {
  const { cover } = useContext(myContext);
  const { itemId } = props;
  const navigate = useNavigate();
  const [visible, setVisible] = useState<boolean>(false);
  const [type, setType] = useState<number>(1);
  const [imgObj, setImgObj] = useState<any>(null);

  const handleAddRemoteImg = (url: string) => {
    const i = new Image();
    i.setAttribute('crossOrigin', 'anonymous');
    i.src = url;
    i.onload = function () {
      const fabricImage = new fabric.Image(i, {
        crossOrigin: 'anonymous'
      });
      let scaleY = Math.round((canvasConfig.customHeight / i.height) * 100) / 100;
      setImgObj({
        width: Math.round(i.width * scaleY),
        height: Math.round(i.height * scaleY)
      });
      fabricImage.set({
        left: (canvasConfig.customWidth - i.width * scaleY) / 2,
        top: canvasConfig.customHeight * 0.1,
        scaleX: scaleY,
        scaleY,
        width: i.width,
        height: i.height,
        cornerStyle: 'circle',
        transparentCorners: true,
        cornerSize: 6,
        rx: 40,
        visible: true,
        selectable: false
      });
      canvasIns?.add(fabricImage);
      canvasIns?.requestRenderAll();
    };
  };

  const setBackground = (mainBg, currentCanvas: any) => {
    let w = window.innerWidth;
    const i = new Image();
    i.setAttribute('crossOrigin', 'anonymous');
    i.src = mainBg;
    i.onload = function () {
      const fabricImage = new fabric.Image(i, {
        crossOrigin: 'anonymous'
      });
      fabricImage.scaleToWidth(i.width).set({
        scaleX: i.width / i.width,
        scaleY: i.height / i.height
      });

      currentCanvas?.setBackgroundImage(fabricImage, currentCanvas.renderAll.bind(currentCanvas), {
        excludeFromExport: true,
        top: 100,
        left: (w - i.width) / 2
      });
      currentCanvas?.requestRenderAll();
    };
  };

  useEffect(() => {
    canvasIns = new fabric.Canvas('J_canvas', {
      controlsAboveOverlay: true,
      enableRetinaScaling: true,
      selection: false
    });
    let w = window.innerWidth;
    canvasIns.setWidth(w);
    canvasIns.setHeight(w * 1.2);

    handleAddRemoteImg(cover);
  }, []);
  return (
    <div className='review-home'>
      <HeaderBar bgImg='radial-gradient(transparent, transparent)' showShare={false} />
      <div className='review-con'>
        <div className='cover-bg'>
          <canvas id='J_canvas' />
        </div>
      </div>
      <div className='product-list'>
        <h3 className='title'>Recommended design</h3>
        <div className='list-con'>
          <div
            className='item-product'
            onClick={() => {
              navigate(`/edit?width=${imgObj.width}&height=${imgObj.height}`, { replace: true });
            }}
          >
            <img src='https://static.hhocool.com/images/550a5e6c-cf12-432c-8362-e756762230ee_100x144.png' />
          </div>
        </div>
      </div>
      <div className='bottom-func'>
        <div className='bar-actions'>
          <div
            className='action-item action-group'
            onClick={() => {
              location.href = 'https://hholove.com/collections/custom-collection?utm_source=hholove&utm_medium=referral&utm_campaign=app'
            }}
          >
            <span className='action-group-item cart_bg'>
              View ProductList
            </span>
          </div>
          <div
            className='action-item action-group'
            onClick={() => {
              location.href = 'https://hholove.com/collections/custom-collection?utm_source=hholove&utm_medium=referral&utm_campaign=app'
            }}
          >
            <div className='action-group-item'>
              <span className='buy_title'>Customize Other</span>
            </div>
          </div>
        </div>
      </div>
      <ProductBuy
        type={type}
        cover={cover}
        canvasIns={canvasIns}
        itemId={itemId}
        visible={visible}
        setVisible={setVisible}
      />
    </div>
  );
};

export default Home;
